import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";

import configureStore from './configure-store';
import ErrorBoundary from "hooks/error-boundary";
import App from "./components/app";

const store = configureStore({});
const root = createRoot(document.getElementById("app"));

const Root = () => {
    useEffect(() => {
        console.log('App rendered!');
    });

    useEffect(() => {
        return () => {
            globalEventListener.cleanUp();
        }
    }, []);

    return (
        <Provider store={store}>
            {/* <StrictMode> */}
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
            {/* </StrictMode> */}
        </Provider>
    );
}

root.render(<Root />);

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js');
}